import '../commons';
import '../uikitv2-user';

import 'jquery-lazy';
// include from proengsoft/laravel-jsvalidation in laravel framework
// https://github.com/proengsoft/laravel-jsvalidation

//have error webpack
//import '../../../../../../public/vendor/jsvalidation/js/jsvalidation'

/*
 ต้องใช้ v.13.0.3 เพราะ ntl-tel-input ver 14ขึ้นไป remove jquery dependency
https://github.com/jackocnr/intl-tel-input/issues/774
*/
import intlTelInput from 'intl-tel-input';
import { log } from 'util';
window.intlTelInput = intlTelInput;

$(function () {
    $(document).ready(function () {
        scrollSpeed(150, 1600);

        //fix mobile ios not support background-attachment: fixed set to : scroll
        if (isMobileSafari()) {
            // Get all elements that have a style attribute
            setTimeout(() => {
                $('div[style*="background-attachment: fixed"]').each(function (i, ele) {
                    ele.style.setProperty('background-attachment', 'scroll');
                });
            },3000);
        }

        function isMobileSafari() {
            return window.navigator.userAgent.match(/(iPod|iPhone|iPad)/) && window.navigator.userAgent.match(/AppleWebKit/)
        }
    });

});
